import React, { PureComponent } from "react";
import t from "@zendesk/client-i18n-tools";

import styles from "./styles.css";

export default class NoResults extends PureComponent {
  render() {
    return (
      <div className={styles.noResults} data-test-id="filter-menu-no-results">
        {t("knowledge-verification.noResults")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/NoResults.js